export default "__VITE_ASSET__DWk7QkrB__"